//Extras
import { memo } from "react"
import { main } from "../../../assets/coach-assets/constants/colors"
import { IoClose } from "react-icons/io5";
import { fontType } from "../../../assets/extras";

const ClasesMuestra = ({ variables, setVariables }) => {

    //Funcion que transforma la fecha
    const getFecha = (fechaStr) => {
        const diasSemana = [
            "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
        ]
        const meses = [
            "enero", "febrero", "marzo", "abril", "mayo", "junio",
            "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
        ]

        // Asegura que la fecha tenga el formato yyyy-mm-dd con ceros
        const [anio, mes, dia] = fechaStr.split('-').map(n => parseInt(n, 10))
        const fecha = new Date(anio, mes - 1, dia) // Date(mesIndexadoDesdeCero)

        const diaSemana = diasSemana[fecha.getDay()]
        const mesNombre = meses[fecha.getMonth()]
        const mesCapitalizado = mesNombre.charAt(0).toUpperCase() + mesNombre.slice(1)

        return `${diaSemana} ${fecha.getDate()} de ${mesCapitalizado} del ${fecha.getFullYear()}`
    }

    //Formatea el subtitulo
    const subtitle = (dias_clase) => {
        let dias = ""
        let hora = ""
        dias_clase.map(v => {
            let dia = ""
            for (let i = 0; i < 3; i++) {
                dia += v.dia[i]
            }
            if (dias) {
                dias += " / " + dia
            } else {
                dias = dia
                hora = v.de + " a " + v.a
            }
        })
        return dias + " de " + hora
    }

    return (
        <div>
            {variables.showClasesMuestra && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1001
                    }}
                >
                    <div
                        style={{
                            width: "90%",
                            height: 500,
                            borderRadius: 20,
                            padding: 20,
                            backgroundColor: "white",
                            display: "flex",
                            flexDirection: "column",
                            position: "relative",
                            maxWidth: 700
                        }}
                    >
                        <IoClose
                            size={24}
                            color="red"
                            style={{
                                position: "absolute",
                                top: 15,
                                right: 15,
                                cursor: "pointer"
                            }}
                            onClick={() =>
                                setVariables(prev => ({
                                    ...prev,
                                    showClasesMuestra: false
                                }))
                            }
                        />

                        <p
                            style={{
                                fontSize: 25,
                                fontWeight: "bold",
                                marginBottom: 20,
                                width: "100%",
                                textAlign: "center",
                                fontFamily: fontType.title
                            }}
                        >
                            Clases muestra
                        </p>

                        <div style={{ width: "100%", overflowY: "auto", maxHeight: 400 }}>
                            {variables.clasesMuestra.map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        padding: "20px 10px 10px 10px",
                                        border: `2px solid ${main}`,
                                        borderRadius: 10,
                                        marginBottom: 10,
                                        width: "100%"
                                    }}
                                >
                                    <p style={{ fontWeight: "bold", fontSize: 15, fontFamily: fontType.title }}>{item.nombre}</p>
                                    <p style={{ marginTop: 10, fontFamily: fontType.text }}>{getFecha(item.fecha_clase)}</p>
                                    <p style={{ marginTop: 30, fontWeight: "bold", width: "100%", fontFamily: fontType.text }}>
                                        {item.nombre_clase}
                                    </p>
                                    <p style={{ fontWeight: "bold", width: "100%", fontFamily: fontType.text }}>
                                        {subtitle(item.dias_clase)}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default memo(ClasesMuestra)